import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-surface-800 text-white">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/58981b16-d987-4368-9007-d3ade5fecfc1.png"
                alt="Arsam.com"
                className="w-8 h-8 object-contain"
              />
              <span className="text-lg font-bold text-white">Arsam.com</span>
            </Link>
            <p className="text-sm text-surface-400 leading-relaxed max-w-xs">
              Türkiye'nin arsa odaklı ilan platformu. Hızlıca ilan ver,
              kolayca arsa bul. Yatırımlık arsalar, imarlı arsalar ve tarla
              ilanları tek platformda.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              Hızlı Linkler
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Anasayfa", path: "/" },
                { label: "İlanlar", path: "/ilanlar" },
                { label: "İlan Ver", path: "/ilan-ver" },
                { label: "Panelim", path: "/panelim" },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-surface-400 hover:text-primary-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              Kategoriler
            </h4>
            <ul className="space-y-3">
              {[
                "Yatırımlık Arsalar",
                "İmarlı Arsalar",
                "Tarla ve Ziraat",
                "Villa Arsaları",
                "Ticari Arsalar",
              ].map((cat) => (
                <li key={cat}>
                  <Link
                    to="/ilanlar"
                    className="text-sm text-surface-400 hover:text-primary-300 transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              İletişim
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-sm text-surface-400" />
                </div>
                <span className="text-sm text-surface-400">
                  destek@arsam.com
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-sm text-surface-400" />
                </div>
                <span className="text-sm text-surface-400">
                  0850 123 45 67
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sm text-surface-400" />
                </div>
                <span className="text-sm text-surface-400">
                  İstanbul, Türkiye
                </span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {[
                "ri-facebook-fill",
                "ri-instagram-line",
                "ri-twitter-x-line",
                "ri-linkedin-fill",
              ].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-surface-700 text-surface-400 hover:bg-primary-500 hover:text-white transition-colors"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-surface-700 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-surface-500">
            &copy; 2024 Arsam.com. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              rel="nofollow"
              className="text-xs text-surface-500 hover:text-surface-300 transition-colors"
            >
              Gizlilik Politikası
            </a>
            <a
              href="#"
              rel="nofollow"
              className="text-xs text-surface-500 hover:text-surface-300 transition-colors"
            >
              Kullanım Koşulları
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}